module.exports = __webpack_public_path__ + "static/together_bg1-3d175c519b2aec73fc70155677148b25.png";